module.exports = __webpack_public_path__ + "static/img/cabecera3.26121436.jpeg";